import Cookies from "js-cookie";

import { COOKIE_CSRF_TOKEN } from "./constants";

export const getAntiCSRFToken = () => Cookies.get(COOKIE_CSRF_TOKEN);
